
export const isEmailValid = (email) => {
  const reg = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return reg.test(email);
};

export const isDNIValid = (dni) => {
  if (dni.length < 8) {
    return false;
  }
  // Comprobamos que las dos primeras posiciones empiecen por letras
  if (dni[0].toLowerCase() !== dni[0].toUpperCase() && dni[1].toLowerCase() !== dni[1].toUpperCase()) {
    if (dni.toUpperCase().startsWith('PT')) {
      return isDNIValidPt(dni.substring(2))
    } else {
      return true;
    }
  }

  let numero, letra;
  let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

  dni = dni.toUpperCase();

  if(expresion_regular_dni.test(dni) === true){
    numero = dni.substr(0,dni.length-1);
    numero = numero.replace('X', 0);
    numero = numero.replace('Y', 1);
    numero = numero.replace('Z', 2);
    let l = dni.substr(dni.length-1, 1);
    numero = numero % 23;
    letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
    letra = letra.substring(numero, numero+1);
    if (letra !== l) {
      //alert('Dni erroneo, la letra del NIF no se corresponde');
      return false;
    }else{
      //alert('Dni correcto');
      return true;
    }
  }else{
    //alert('Dni erroneo, formato no válido');
    return false;
  }
};

export const isDNIValidPt = (nif) => {
  if(nif.length === 9){
    const added = ((nif[7]*2)+(nif[6]*3)+(nif[5]*4)+(nif[4]*5)+(nif[3]*6)+(nif[2]*7)+(nif[1]*8)+(nif[0]*9));
    const mod = added % 11;
    let control;
    if (mod === 0 || mod === 1) {
      control = '0';
    } else {
      control = `${11 - mod}`;
    }

    if (nif[8] === control) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const isCCCValid = (ccc) => {
  const reg = /^[0-9]+$/;
  return reg.test(ccc) && ccc.length === 11;
};

export const Int = (value) => {
  return parseInt(String(value || -1), 10);
};



// WEBPACK FOOTER //
// ./src/app/shared/utils/StringUtils.js